/**
 * O contorno de cada tipo de ajuda na Calculadora Petrella.
 *
 * Papel: reproduz o `#ac-card-*` (l. 1001–1047) e o quadro da diarista
 * (l. 1078): borda bege de 1 px, raio de 8 px, `10px 12px`, 8 px abaixo.
 *
 * Como usar: o quadro da diarista não tem a margem de baixo, e a tira por
 * `className`, aplicado depois.
 */
import { type ComponentProps } from 'react';

import { cn } from '@/shared/lib/utils';

/**
 * O cartão de um tipo.
 *
 * @param className - Classes de quem chama, aplicadas por último.
 * @returns O `<div>` do cartão.
 */
export function CartaoDeTipo({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn('mb-2 rounded-[8px] border border-emb-borda px-3 py-2.5', className)}
      {...props}
    />
  );
}
